import { graphql } from "@/graphql/generated";
import { MunicipalPropertyHistoryQuery, MunicipalPropertyHistoryQueryVariables } from "@/graphql/generated/graphql";
import { TypedDocumentNode } from "@graphql-typed-document-node/core";

export const MUNICIPAL_PROPERTY_HISTORY_QUERY_DOCUMENT: TypedDocumentNode<
  MunicipalPropertyHistoryQuery,
  MunicipalPropertyHistoryQueryVariables
> = graphql(`
  query MunicipalPropertyHistory($input: MunicipalPropertyHistoryInput!) {
    municipalPropertyHistory(input: $input) {
      effectiveYearList effectiveYear standUpdatedAt
      property {
        id workspaceId name type description street houseNumber postalCode city usableFloorAreaM2
        commissioningYear createdAt updatedAt archivedAt municipalityList { id name }
      }
    }
  }
`);
